import { getBrand, getCurrentClient } from '@/config/brand'

export default {
  computed: {
    currentClient() {
      return getCurrentClient()
    },
    brand() {
      return getBrand(this.currentClient)
    },
    brandLogo() {
      return this.brand.logos.main
    },
    brandIcon() {
      return this.brand.logos.icon
    },
  },
}
